import { AppLanguage, SUPPORTED_LANGUAGES } from '@common/utils/lang';

import { Environment } from './environment.interface';

export const environment: Environment = {
  production: false,
  baseUrl: 'https://dev.axenta.cloud/',
  apiUrl: 'https://dev.axenta.cloud/api/',
  websocketUrl: 'wss://dev.axenta.cloud/ws/',
  locales: SUPPORTED_LANGUAGES,
  defaultLocale: AppLanguage.English,
  systemType: 'monitoring',
  tokenKey: 'token',
  objectIconsUrl: 'http://192.168.3.131:8333/account-icons/',
  fullAccessTokenKey: 'full_access',
  flagsmithEnvironmentId: '7XwyFQc4huk9SdDaa2qJbB',
  flagsmithApiUrl: 'https://features.axenta.cloud/api/v1/',
};
